/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const StoreActiveIcon: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_40000726_4487)">
      <rect width="24" height="24" fill="white" />
      <rect width="24" height="24" transform="translate(0 0.374023)" fill="white" />
      <path
        d="M3.4 5.84102C3.14036 6.18722 3 6.60828 3 7.04102V20.374C3 20.9045 3.21071 21.4132 3.58579 21.7882C3.96086 22.1633 4.46957 22.374 5 22.374H19C19.5304 22.374 20.0391 22.1633 20.4142 21.7882C20.7893 21.4132 21 20.9045 21 20.374V7.04102C21 6.60828 20.8596 6.18722 20.6 5.84102L18.6 3.17402C18.4137 2.92563 18.1721 2.72402 17.8944 2.58517C17.6167 2.44631 17.3105 2.37402 17 2.37402H7C6.68951 2.37402 6.38328 2.44631 6.10557 2.58517C5.82786 2.72402 5.58629 2.92563 5.4 3.17402L3.4 5.84102Z"
        fill="#262626"
        stroke="#262626"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.374C16 11.4349 15.5786 12.4523 14.8284 13.2025C14.0783 13.9526 13.0609 14.374 12 14.374C10.9391 14.374 9.92172 13.9526 9.17157 13.2025C8.42143 12.4523 8 11.4349 8 10.374"
        stroke="#F4F4F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.10352 6.40802H20.8975"
        stroke="#F4F4F4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40000726_4487">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default StoreActiveIcon;
